module.exports = __webpack_public_path__ + "media/images/Button-Download-icon-85f73ceed937712f317c147fc14de61c.png";